import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorGlobal, successGlobal } from '../reducers/notifications';
import { getAuthHeader } from '../../utils/tools';
import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json';

export const fetchBranches = createAsyncThunk(
    'branch/fetchBranches',
    async(_, { dispatch }) => {
        try {
            const request = await axios.get(`/api/branch/fetch`, getAuthHeader());
            return request.data;
        } catch(error) {
            // 403 here means the user simply doesn't have the "waste" module - not an error to alarm them about
            if (error.response?.status !== 403) {
                dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            }
            throw error;
        }
    }
)

export const setCurrentBranch = (branchId) => {
    return {
        type: 'branch/setCurrentBranch',
        payload: branchId
    };
};

// Add new Branch
export const addBranch = createAsyncThunk(
    'branch/addBranch',
    async(data, {dispatch}) => {
        try {
            const { name, contact, street, buildingNumber, registrationNumber, zip, city, responsiblePerson } = data;
            const address = {
                street: street,
                buildingNumber: buildingNumber,
                registrationNumber: registrationNumber,
                zip: zip,
                city: city
            }

            const request = await axios.post(`/api/branch/create`,
                {
                    name,
                    contact,
                    address,
                    responsiblePerson
                },
                getAuthHeader()
            );

            dispatch(successGlobal('Prevádzka bola úspešne vytvorená.'));
            return request.data;

        } catch(error) {
            dispatch(errorGlobal('Prevádzku sa nepodarilo vytvoriť.'));
            throw error;
        }
    }
);

// Get Branch by ID
export const getBranchById = createAsyncThunk(
    'branch/getBranchById',
    async(branchId, {dispatch}) => {
        try {
            const request = await axios.get(`/api/branch/get-by-id`, {
                params: {
                    branchId,
                },
                ...getAuthHeader()
            });

            return request.data;

        } catch(error) {
            dispatch(errorGlobal('Prevádzku sa nepodarilo načítať'));
            throw error;
        }
    }
);

// Edit Branch
export const editBranch = createAsyncThunk(
    'branch/editBranch',
    async({branchId, values}, {dispatch}) => {
        try {
            const request = await axios.patch(`/api/branch/edit`, 
                { branchId, values },  // Send branchId and values like payload
                getAuthHeader(),  // Send authentification headers
            
            );
            dispatch(successGlobal('Prevádzka bola úspešne upravená.'));
            return request.data;
        } catch(error) {
            dispatch(errorGlobal('Prevádzku sa nepodarilo upraviť!'));
            throw error;
        }
    }
);

// Delete branch
export const deleteBranch = createAsyncThunk(
    'branch/deleteBranch',
    async(branchId, {dispatch}) => {
        try {
            const request = await axios.delete(`/api/branch/delete`, {
                data: { branchId },
                ...getAuthHeader()
            });
            return request.data;
        } catch(error) {
            dispatch(errorGlobal('Prevádzku sa nepodarilo vymazať!'));
            throw error;
        }
    }
);